import { Customer } from '@/shared/model/customer.model';
import DataService from '@/core/base/service/data.service';
import { IUser } from '@/shared/model/user.model';
import axios from 'axios';
import { ICampaign } from '@/shared/model/campaign.model';

export default class CustomerService extends DataService<Customer> {
    baseApiUrl: string = 'api/customers';

    public async createUser(customerId: number, user: IUser): Promise<IUser> {
        return new Promise<IUser>((resolve, reject) => {
            axios
                .post(`${this.baseApiUrl}/${customerId}/users`, user)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public async createCampaign(customerId: number, campaign: ICampaign): Promise<ICampaign> {
        return new Promise<ICampaign>((resolve, reject) => {
            axios
                .post(`${this.baseApiUrl}/${customerId}/campaigns`, campaign)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public async removeUser(customerId: number, userId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            axios
                .delete(`${this.baseApiUrl}/${customerId}/users/${userId}`)
                .then(res => {
                    resolve();
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}
